module.exports = angular.module('add-to-segment-form', [
    require('../../../controllers/triggerPanel/addToSegmentFormCtrl').name
])
    .directive('addToSegmentForm', function () {
        return {
            restrict: 'E',
            scope: false,
            templateUrl: 'app/views/triggerPanel/add-to-segment-form.tpl.html',
            controller: 'addToSegmentFormCtrl'
        };
    });



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/triggerPanel/add-to-segment-form.js